import { B2B_ORGANIZATION_ACTIONS } from 'actions/b2b-organization';
import { Store } from 'store/types';
import { B2BOrganization } from 'types/b2b-organization';

export const checkAndSetCurrentOrganizationNumber = (
  store: Store,
  currentOrganizationNumber: string | undefined,
  list: B2BOrganization[],
) => {
  store.dispatch(B2B_ORGANIZATION_ACTIONS.success, list);

  if (list.length > 0) {
    const organization = list.find((el) => el.organizationNumber === currentOrganizationNumber);
    const newOrganizationNumber = organization
      ? organization.organizationNumber
      : list[0].organizationNumber;

    store.dispatch(B2B_ORGANIZATION_ACTIONS.setCurrentOrganizationNumber, newOrganizationNumber);
  }
};
